import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useModuleAccess } from './useModuleAccess';
import routes_web from './routes_web';
import { useEffect } from 'react';

const ModuleRoute = ({ moduleName }) => {
  const { hasAccess } = useModuleAccess();
  const moduleHasAccess = hasAccess(moduleName);

  useEffect(() => {
    if (!moduleHasAccess) {
      toast.error('You do not have access to this module');
    }
  }, [moduleHasAccess]);

  if (!moduleHasAccess) {
    return <Navigate to={routes_web.accounts_main} replace />;
  }

  return <Outlet />;
};

export default ModuleRoute;